import {useEffect, useState} from 'react'
import {useSearchParams, useNavigate} from 'react-router-dom'

import PaymentWidget from 'widget/PaymentWidget'

import {
	convertProGradeAsName,
	ROOKIE,
	SEMI,
	TOUR,
} from 'shared/constant/lookup/proGrade'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const TryoutExamPayment = () => {
	const navigate = useNavigate()

	const [searchParams] = useSearchParams()
	const proGradeType = parseInt(searchParams.get('proGradeType'))
	const examIdx = parseInt(searchParams.get('examIdx'))
	const price = parseInt(searchParams.get('price'))
	const branchName = searchParams.get('branchName')

	const [isError, setIsError] = useState(true)

	const [, setAlert] = useAlertModalAtom()

	// query 예외처리
	useEffect(() => {
		if (![ROOKIE, SEMI, TOUR].includes(proGradeType)) {
			setAlert('대상 프로 자격이 올바르지 않습니다.')
			navigate('/tryout')
		} else if (!examIdx || examIdx == '') {
			setAlert('필기 시험 idx가 올바르지 않습니다.')
			navigate('/tryout')
		} else {
			setIsError(false)
		}
	}, [])

	const props = {
		amount: price,
		orderName: `${convertProGradeAsName[proGradeType]} 프로 자격 필기 시험 응시권${branchName ? ` - ${branchName}` : ''}`,
		callbackUrl: `exam/done?examIdx=${examIdx}`,
	}

	return !isError && <PaymentWidget {...props} />
}

export default TryoutExamPayment
